import t from 'tcomb';
import Registered from './Registered';
import Verified from './Verified';

const Logged_User = t.union([Registered, Verified]);

module.exports = Logged_User;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Logged_User.js
 **/